import { useState, type ImgHTMLAttributes } from "react"
import { HiPhoto } from "react-icons/hi2"
import { cn } from "~/lib/utils"

export function RemoteImg({ className, alt = "", onError, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return (
      <div
        role="img"
        aria-label={alt}
        className={cn("flex items-center justify-center bg-muted text-muted-foreground", className)}
      >
        <HiPhoto className="size-1/3 opacity-60" />
      </div>
    )
  }

  return (
    <img
      {...props}
      alt={alt}
      className={className}
      onError={(event) => {
        setFailed(true)
        onError?.(event)
      }}
    />
  )
}
